import { JUDGE_IS_LOGIN } from '@store/officialTopupNew/login';
import { GET_ACTIVITY_LIST } from '@store/officialTopupNew/activity';
import { GET_SEPC_GAME_INFO } from '@store/officialTopupNew';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  LOAD_GAME_COUPON_LIST,
  LOAD_VIP_COUPON_INFO
} from '@store/store/coupon';
import { mapGetters } from 'vuex';

export default {
  computed: {},
  methods: {
    globalBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
        if (!res) {
          this.getActivityList();
          return;
        }
        let canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: this.$store.state.gameId
        });
        if (!canContinue) {
          globalConfig.jumpErrorPage({
            jump404Reason: 'no_can_continue',
            canContinue: canContinue,
          });
        }
        //  2024-04-09 :修复因接口请求顺序错误，导致登录态异常（这个接口也需要登录态，所以登录成功再请求好了）
        this.$store.dispatch(LOAD_GAME_COUPON_LIST);
        // this.$store.dispatch(LOAD_VIP_COUPON_INFO);
      });
    },
    jpBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(res => {
        if (!res) {
          this.getActivityList();
          return;
        }
      });
    },
    getActivityList() {
      this.$store.dispatch(GET_ACTIVITY_LIST, {
        pos: ['index_banner', 'popup', 'lamp', 'time_award', 'recommend', 'hero_section']
      });
    }
  },
  created() {
    this.$store.getters.isJpPlatform
      ? this.jpBeforeCreate()
      : this.globalBeforeCreate();
  }
};
